/**
 * Utilitário de logging condicional
 * Oculta logs em produção para segurança
 */

const isProduction = import.meta.env.PROD;

export const logger = {
  /**
   * Log informativo - oculto em produção
   */
  log: (...args: unknown[]) => {
    if (!isProduction) {
      console.log(...args);
    }
  },

  /**
   * Log de aviso - oculto em produção
   */
  warn: (...args: unknown[]) => {
    if (!isProduction) {
      console.warn(...args);
    }
  },

  /**
   * Log de erro - SEMPRE visível (necessário para debugging crítico)
   */
  error: (...args: unknown[]) => {
    console.error(...args);
  },

  /**
   * Log de debug - oculto em produção, com prefixo [DEBUG]
   */
  debug: (...args: unknown[]) => {
    if (!isProduction) {
      console.log('[DEBUG]', ...args);
    }
  },

  /**
   * Log de informação do sistema - oculto em produção
   */
  info: (...args: unknown[]) => {
    if (!isProduction) {
      console.info(...args);
    }
  },
};

export default logger;
